import { Currency } from 'nomst/Stores/Utility/currency';
import SafeMath from 'common/safeMath';

export class CurrencyTransformer {
    static transformToAllTargetCurrencies(currencies: ICurrency[]): Currency[] {
        return ([] as Currency[]).concat(...currencies.map(sourceCurrency =>
            CurrencyTransformer.getAllTargetCurrencyConversionsFromSourceCurrency(
                sourceCurrency,
                currencies)));
    }

    private static getAllTargetCurrencyConversionsFromSourceCurrency(
        sourceCurrency: ICurrency,
        currencies: ICurrency[]): Currency[] {
        return currencies.map(targetCurrency => new Currency(
            sourceCurrency.currencyCode,
            targetCurrency.currencyCode,
            SafeMath.divide(sourceCurrency.ratio, targetCurrency.ratio)));
    }
}